export default __webpack_public_path__ + "06b5c8c82776a9718b8159fd9faa3fc3.png";